module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAATCAYAAABGKffQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABFSURBVHgB7ZMxEQAgDAMrAQmVhAQk4ACcIAlJgR4dGbJ06991++8WEQIA9Z4y4sCjseJM8Seqi1sY7KMHK4OIoLOBLaUcbHbHq0i3i3EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mLeft.png
// module id = I+JF
// module chunks = 1